<div id="backdrop" class="modal-backdrop" [ngClass]="{ show: showModal }" style="z-index: 900"></div>
<div class="modal d-block fade" 
  [ngClass]="{ show: showModal }"
  id="listing-dialog" 
  tabindex="-1" role="dialog" aria-labelledby="modalIdLabel">
    <div class="modal-dialog mw-100" style="width: 60%; margin-top: 50px" role="document" (click)="onDialogClick($event)">
        <div class="modal-content">
            <div class="modal-header">
                <h5 *ngIf="showModal"><strong>Stamm - Arbeitszeiten</strong></h5>
                <button type="button"
                    class="close"
                    (click)="goBack()"
                    aria-label="Close"><span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">

              <form [formGroup]="defaultTimesForm" (ngSubmit)="onSubmit()">
                <div formArrayName="defaultTimes" class="w-full">
                  <div *ngFor="let time of defaultTimesForm.get('defaultTimes')['controls']; let i = index" [formGroupName]="i" 
                      [ngClass]="{'bg-red-400': time.get('active').value == 0 , 'bg-gray-600': time.get('active').value == 1}"
                       class="form-row flex items-center mb-0.5" style="padding-right: 5px">
                    
                    <!-- Tag (Montag bis Sonntag) -->
                    <div class="form-group flex-1 m-0 p-1 text-white"   [ngClass]="{'bg-red-400': time.get('active').value == 0 , 'bg-gray-600': time.get('active').value == 1}" >
                      <strong>{{ getDayName(i) }}</strong>
                    </div>
              
                    <!-- Aktiv (true/false) -->
                    <div class="form-group flex-1 m-0 p-0" style="width: 100px;">
                      <select formControlName="active" class="form-control" style="width: 100px;">
                        <option [value]=1>Aktiv</option>
                        <option [value]=0>Inaktiv</option>
                      </select>
                    </div>
              
                    <!-- Startzeit -->
                    <div class="form-group flex-1 m-0 p-0">
                      <input type="number" formControlName="default_start" class="form-control" placeholder="Startzeit" style="width: 100px;">
                    </div>
              
                    <!-- Endzeit -->
                    <div class="form-group flex-1 m-0 p-0">
                      <input type="number" formControlName="default_end" class="form-control" placeholder="Endzeit" style="width: 100px;">
                    </div>
              
                    <!-- Stunden (kleinere Größe) -->
                    <div class="form-group flex-0 m-0 p-0" style="width: 60px;">
                      <input type="number" formControlName="hours" class="form-control" placeholder="Stunden" readonly>
                    </div>
              
                    <!-- Notiz (größerer Platz) -->
                    <div class="form-group flex-3 m-0 p-0">
                      <input type="text" formControlName="note" class="form-control" placeholder="Notiz">
                    </div>
              
                  </div>
                </div>
              
                <button type="submit" class="btn btn-primary mt-1">Speichern</button>
              </form>
              
              
              
              
              
              

</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="goBack()">schließen</button>
</div>
</div>
</div>
</div>


